import React from 'react';
import { Link } from 'react-router-dom';
import './StaticPages.css';

export default function About() {
  return (
    <div className="static-page">
      <div className="page-header">
        <h1>About Us</h1>
        <p>Our story, mission and values</p>
      </div>

      <div className="container static-content">
        {/* Mission */}
        <section className="about-mission">
          <div className="about-mission-text">
            <div className="section-badge">🪷 Our Mission</div>
            <h2>Uniting Hearts with <span className="text-gold">Traditional Values</span></h2>
            <div className="gold-divider" style={{margin:'12px 0 20px'}} />
            <p>Our mission is to create a trusted matrimony platform where individuals and families can confidently search for their life partners using modern technology and traditional values.</p>
            <p>At Suvaran Maran Matrimony, we understand the importance of finding the right life partner. That's why we've built a platform that respects traditional Hindu values while using modern technology to make matchmaking simple, secure, and meaningful.</p>
            <p><strong>உங்கள் வாழ்க்கை துணையை கண்டறியுங்கள்</strong> — Find Your Perfect Life Partner.</p>
          </div>
          <div className="about-mission-stats">
            {[
              { n: '2,547+', l: 'Registered Profiles' },
              { n: '847+', l: 'Successful Marriages' },
              { n: '100%', l: 'Admin Verified' },
              { n: '₹499', l: 'One-Time Payment' },
            ].map(s => (
              <div key={s.l} className="about-stat">
                <strong>{s.n}</strong>
                <span>{s.l}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Our Speciality */}
        <section className="about-section">
          <h2 className="section-title text-center">Our Speciality</h2>
          <div className="gold-divider" />
          <div className="about-cards">
            {[
              { icon: '🛡️', title: 'Sutham Shield', desc: 'Sutham profiles are exclusively shown to Sutham members only. We guarantee 100% separation between horoscope types.' },
              { icon: '⭐', title: '27 Nakshatra Matching', desc: 'Our algorithm uses all 27 nakshatras for compatibility scoring. Birth star matching contributes 25% to the total match score.' },
              { icon: '🔒', title: 'Contact Privacy', desc: 'Phone numbers are never shown directly. The opposite person must approve your contact request before their number is revealed.' },
              { icon: '👨‍💼', title: 'Admin Verified', desc: 'Every profile and payment is manually verified by our admin. Only genuine, verified profiles are shown to members.' },
            ].map(c => (
              <div key={c.title} className="about-card">
                <div className="about-card-icon">{c.icon}</div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Horoscope Types */}
        <section className="about-section">
          <h2 className="section-title text-center">Horoscope Type System</h2>
          <div className="gold-divider" />
          <div className="horo-table">
            <table>
              <thead>
                <tr><th>Your Type</th><th>You Can See</th><th>Match %</th></tr>
              </thead>
              <tbody>
                <tr><td><span className="badge badge-sutham">Sutham</span></td><td>Sutham only</td><td>100%</td></tr>
                <tr><td><span className="badge badge-seva">Seva</span></td><td>Seva + Seva,Rahu Ketu</td><td>100% / 70%</td></tr>
                <tr><td><span className="badge badge-rahuketu">Rahu Ketu</span></td><td>Rahu Ketu + Seva,Rahu Ketu</td><td>100% / 70%</td></tr>
                <tr><td><span className="badge badge-sevarahu">Seva, Rahu Ketu</span></td><td>Seva + Rahu Ketu + Seva,Rahu Ketu</td><td>100%</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* CTA */}
        <div className="about-cta">
          <h2>Ready to Find Your Life Partner?</h2>
          <p>Join thousands of Tamil Hindu families who trust Suvaran Maran Matrimony.</p>
          <Link to="/register" className="btn btn-gold btn-lg">🪷 Create Your Profile</Link>
        </div>
      </div>
    </div>
  );
}
